import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from 'src/app/globals';
import { EnumeracaoBO } from 'src/app/models/enumeracao';

@Injectable({
  providedIn: 'root'
})
export class CrmenumService {

  constructor(private http: HttpClient) { }

  consultarStatusDaOportunidade() {
    return this.http.get<EnumeracaoBO[]>(globals.apiUrl + '/api/CRMEnum/StatusDaOportunidade');
  }

  consultarPeriodosDaMeta() {
    return this.http.get<EnumeracaoBO[]>(globals.apiUrl + '/api/CRMEnum/PeriodosDaMeta');
  }

  consultarTiposDaMeta() {
    return this.http.get<EnumeracaoBO[]>(globals.apiUrl + '/api/CRMEnum/TiposDaMeta');
  }

  consultarDuracoesDaAtividade() {
    return this.http.get<EnumeracaoBO[]>(globals.apiUrl + '/api/CRMEnum/DuracoesDaAtividade');
  }

  consultarAcaoAtividadeResponsaveis() {
    return this.http.get<EnumeracaoBO[]>(globals.apiUrl + '/api/CRMEnum/AcaoAtividadeResponsaveis');
  }

  consultarAcaoDuplicarDonos() {
    return this.http.get<EnumeracaoBO[]>(globals.apiUrl + '/api/CRMEnum/AcaoDuplicarDonos');
  }

  consultarAcaoEmailDe() {
    return this.http.get<EnumeracaoBO[]>(globals.apiUrl + '/api/CRMEnum/AcaoEmailDe');
  }

  consultarAcaoEmailPara() {
    return this.http.get<EnumeracaoBO[]>(globals.apiUrl + '/api/CRMEnum/AcaoEmailPara');
  }

  consultarAcaoNotificacaoPara() {
    return this.http.get<EnumeracaoBO[]>(globals.apiUrl + '/api/CRMEnum/AcaoNotificacaoPara');
  }

  consultarIntegracaoTipos() {
    return this.http.get<EnumeracaoBO[]>(globals.apiUrl + '/api/CRMEnum/IntegracaoTipos');
  }

  consultarIntegracaoTiposVolta() {
    return this.http.get<EnumeracaoBO[]>(globals.apiUrl + '/api/CRMEnum/IntegracaoTiposVolta');
  }

  consultarIntegracaoTiposOrigemRD() {
    return this.http.get<EnumeracaoBO[]>(globals.apiUrl + '/api/CRMEnum/IntegracaoTiposOrigemRD');
  }
}
